import React, { Component } from 'react'
import User from 'helper/User';
import {Roles} from 'constants/Roles';
import Confirmalert from 'components/ThemeComponents/confirmAlert';
import { confirmAlert } from 'react-confirm-alert';
import { orderService } from '../../../services/order';
import { Box, Grid } from "@mui/material"
import ReactPlayer from 'react-player';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import VideoPlayer from './VideoPlayer';
class Videos extends Component {

    constructor(props) {
        super(props)
        this.state = {
            videos: [],
            orderUploadInfo: this.props.orderUploadInfo,
            playing: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.orderUploadInfo !== prevProps.orderUploadInfo) {
            this.setState({ orderUploadInfo: this.props.orderUploadInfo});
        }

        // if (this.props.image.updated_at !== prevProps.image.updated_at) {
        //     const image = this.props.image;
        //     this.setState({
        //         path: image.file_path + image.file_title + "." + image.image_format.extension + '?updated_at=' + image.updated_at
        //     })
        // }
    }
    componentDidMount () {
        this.getVideos();
    }

    getVideos = () => {
        orderService.orderVideoListing(User.getProperty('order.id')).then((response) => {
            this.setState({ videos: response.order_videos.data });
            console.log("res", response);

        })
    }

    deleteSelected = (id) => {
        const videos = [];
        videos.push(id);
        
        const data = { videos }
        orderService.deleteVideos(data).then(
            res => {
                this.getVideos();
                if (this.props.callGetVideoInDocument){
                    this.props.callGetVideoInDocument();
                }
            }
        )
    }
    confirmImagesDelete = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (

                    <Confirmalert
                        header={`Delete Video`}
                        description={`Are you sure you want to delete this video file?`}
                        onClosePro={onClose}
                        extraHtml={() => {
                            return (<span>
                                The video file cannot be recovered once deleted
                            </span>);
                        }}
                        onNo={onClose}
                        onYes={() => { this.deleteSelected(id) }}
                        yesLabel='Yes'
                        noLabel='No'
                    />

                )
            }
        })
    }


    ref = player => {
        this.player = player
    }

    toggleVideoKeepsake = (video) => {
        let status = 1 - video.is_approved_for_keepsake;
        console.log("id", video.id, "status", status);
        const data = {order_id: this.props.orderId, is_approved_for_keepsake: status, video_id: video.id};
        orderService.toggleVideoKeepsake(data).then(
            res => {
                this.getVideos();
                this.props.success(res.message);
                this.props.orderInfoCall(this.props.orderId);
            }
        )
    }
    confirmTravelerVideoClipGallery = (key, value) => {
        console.log(value===1);
        confirmAlert({
            customUI: ({ onClose }) => {
                return (

                    <Confirmalert
                        header={`Attendees Video Clip Gallery`}
                        description={
                            value === 1 ? 
                            'By turning OFF the attendees video clip gallery, you-the Photo Admin, will be the only one that can see uploaded videos, any videos left in your gallery will be in your final keepsake video.'
                            :
                            'By turning ON the attendees video clip gallery, you are approving all videos marked ‘Include’ to be seen in the traveler gallery and possibly in the final keepsake video.'}
                        onClosePro={onClose}
                        extraHtml={() => {
                            return (<span>
                            </span>);
                        }}
                        onNo={onClose}
                        onYes={() => { this.updateOrderSettingsHandler(key, value) }}
                        yesLabel={value === 1 ? 'Turn Off' : 'Turn On'}
                        noLabel='Cancel'
                    />

                )
            }
        })
    }

    updateOrderSettingsHandler(key, value) {
        console.log("key", key, "value", value);
        
        this.props.updateOrderSettingsCall(this.props.orderId, value, key).then(response => {
            this.props.orderInfoCall(this.props.orderId);
        });
    }
    handlePlay = () => {
        this.setState({ playing: true });
    };

    downloadVideo = (file) => {
        orderService.getVideoDownloadLink({file: file}).then(
            res => {
                window.open(res.url, '_blank');
            }
        )
    }

    renderVideoGrid = (videoList) => {
        const { orderUploadInfo } = this.state;
        const { photos_submitted_for_video_production } = orderUploadInfo;

        return ( // ✅ must return the JSX here
            <Grid container spacing={4}>
                {videoList.map((video, i) => (
                    <Grid item xs={12} md={6} lg={3} key={video.id || i}>
                        <Box className="galleryFix uploadedImageSize">

                            {/* Delete Button */}
                            {User.hasRole(Roles.PHOTO_ADMIN) && (
                                <button
                                    type="button"
                                    onClick={() => this.confirmImagesDelete(video.id)}
                                    className="delete_img delete_icon hover_dark"
                                    style={{ left: '1rem' }}
                                >
                                    &nbsp;
                                </button>
                            )}

                            {/* Include / Exclude Button */}
                            {User.hasRole(Roles.PHOTO_ADMIN) &&
                                Number(orderUploadInfo.is_traveler_video_clip_gallery.value) === 1 && (
                                    <div
                                        className={
                                            "approvalChk hover_dark" +
                                            (video.is_approved_for_keepsake
                                                ? " gray_gradient"
                                                : " purple_blue_gradient")
                                        }
                                    >
                                        <div className="customChk">
                                            <button
                                                disabled={Number(
                                                    photos_submitted_for_video_production.value
                                                ) === 1}
                                                onClick={() => this.toggleVideoKeepsake(video)}
                                                className={
                                                    video.is_approved_for_keepsake
                                                        ? "checkedBtn checkBtn text_14"
                                                        : "checkBtn text_14"
                                                }
                                                htmlFor={"image_" + video.id}
                                            >
                                                Include
                                            </button>
                                        </div>
                                    </div>
                                )}

                            {/* Download Button */}
                            {User.hasRole(Roles.PHOTO_ADMIN) && (
                                <button
                                    type="button"
                                    onClick={() => this.downloadVideo(video.video_url)}
                                    className="download_video downloadVideoIcon"
                                    style={{ left: "4rem" }}
                                >
                                    &nbsp;
                                </button>
                            )}

                            {/* Video Player */}
                            <VideoPlayer
                                src={video.video_url}
                                type="video/mp4"
                                poster={video.video_thumbnail_url || false}
                                width="90%"
                            />
                        </Box>

                        {/* Uploaded By */}
                        <div className="galleryInfo p-sm">
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id={video.video_url}>Uploaded By</Tooltip>}
                            >
                                <span className="text_16">
                                    {(video.uploaded_by_first_name || "") +
                                        " " +
                                        (video.uploaded_by_last_name || "")}
                                </span>
                            </OverlayTrigger>
                        </div>
                    </Grid>
                ))}
            </Grid>
        );
    };


    render() {
        const { videos, orderUploadInfo } = this.state;
        const {photos_submitted_for_video_production} = orderUploadInfo;

        const includedVideos = videos.filter(v => v.is_approved_for_keepsake);
        const notIncludedVideos = videos.filter(v => !v.is_approved_for_keepsake);
        return (
            <section id="companyImagesInfo">
                <div className='container'>
                    <div className="">
                        <div className="">
                            {/* <p className="gallery_view_box_heading">Gallery Viewing Options</p> */}
                        </div>
                    </div>

                    <div className="row mb-xlg mt-xlg gallery_view_box">
                        <div className='col-md-12 mb-md'>
                            <span>
                                {
                                    User.hasRole(Roles.PHOTO_ADMIN) && 
                                    (
                                        <p className='panel_heading small text_left_center_991'>
                                            {
                                            Number(orderUploadInfo.is_traveler_video_clip_gallery.value) === 1
                                                ? 'Check ‘Included’ to be seen in Video Clip Gallery and possibly in Final Keepsake.'
                                                : 'Traveler Video Clip uploader/viewer is OFF. All video clips uploaded will be included in your final keepsake.'
                                            }
                                        </p>
                                    )
                                }
                                {
                                    User.hasRole(Roles.TRAVELER) && Number(orderUploadInfo.is_traveler_video_clip_gallery.value) === 1 && 
                                    (
                                        <p className='panel_heading small text_left_center_991'>
                                            If you do not see your uploaded video clip, it may not have been approved for viewing yet.
                                        </p>
                                    )
                                }
                            </span>
                        </div>
                        {
                            User.hasRole(Roles.PHOTO_ADMIN) &&
                            <div className='col-md-12 mb-md flexElem'>
                                <p className="gallery_view_box_heading">
                                    Attendees Video Clip Gallery &nbsp;
                                </p>
                                <div>
                                    <input type="checkbox"
                                        onChange={() => this.confirmTravelerVideoClipGallery(orderUploadInfo.is_traveler_video_clip_gallery.key, +orderUploadInfo.is_traveler_video_clip_gallery.value)}
                                        id="switch" checked={+orderUploadInfo.is_traveler_video_clip_gallery.value ? 'checked' : ''}
                                        className="cssSwitch" /><label className="cssSwitch"
                                            htmlFor="switch">Toggle</label>
                                </div>
                            </div>
                        }
                    </div>
                    <Box sx={{ py: 5 }}>
                        {/* Included Videos Section */}
                        <p className='panel_heading small text_left_center_991 mb-md'>
                            Included Videos
                        </p>
                        {
                            this.renderVideoGrid(includedVideos)
                        }

                        {/* Not Included Videos Section */}
                        <p className='panel_heading small text_left_center_991 mt-md mb-md'>
                            Not Included Videos
                        </p>
                        {
                            this.renderVideoGrid(notIncludedVideos)
                        }
                    </Box>
                    {/* <Grid container spacing={4} sx={{ py: 5 }}>
                        {
                            videos.map((video, i) => {
                                return (
                                    <Grid item xs={12} md={6} lg={3} key={i}>
                                        <Box className="galleryFix uploadedImageSize">
                                            {
                                                User.hasRole(Roles.PHOTO_ADMIN) &&
                                                <button type="button" onClick={() => {this.confirmImagesDelete(video.id) }}
                                                    className={'delete_img delete_icon hover_dark'} style={{left:'1rem'}}>
                                                    &nbsp;
                                                </button>
                                            }
                                            {
                                                User.hasRole(Roles.PHOTO_ADMIN) && Number(orderUploadInfo.is_traveler_video_clip_gallery.value) === 1 &&
                                                <div
                                                    className={"approvalChk hover_dark" + (video.is_approved_for_keepsake ? ' gray_gradient' : ' purple_blue_gradient')}>
                                                    <div className="customChk">
                                                        <button 
                                                            disabled={Number(photos_submitted_for_video_production.value) === 1 ? true : false}
                                                            onClick={(e) => {
                                                            this.toggleVideoKeepsake(video)
                                                        }} className={video.is_approved_for_keepsake ? "checkedBtn checkBtn text_14" : "checkBtn text_14"}
                                                                htmlFor={'image_' + video.id}>Include
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            
                                            {
                                                User.hasRole(Roles.PHOTO_ADMIN) &&
                                                <button type="button" onClick={() => {this.downloadVideo(video.video_url) }}
                                                    className={'download_video downloadVideoIcon'} style={{left:'4rem'}}>
                                                    &nbsp;
                                                </button>
                                            }
                                            <VideoPlayer 
                                                src={video.video_url} 
                                                type="video/mp4" 
                                                poster={video.video_thumbnail_url || false}
                                                width="90%"
                                            />
                                           
                                        </Box>
                                        <div className="galleryInfo p-sm">
                                            <OverlayTrigger placement="bottom" overlay={
                                                <Tooltip id={video.video_url}>
                                                    Uploaded By
                                                </Tooltip>
                                            }>
                                                <span className="text_16">
                                                    {(video.uploaded_by_first_name !== null ? video.uploaded_by_first_name : '') +
                                                    ' ' +
                                                    (video.uploaded_by_last_name !== null ? video.uploaded_by_last_name : '')}
                                                </span>
                                            </OverlayTrigger>
                                        </div>
                                    </Grid>
                                );
                            })
                        }
                    </Grid> */}
                </div >
            </section>
        )
    }
}
export default Videos

